import React from 'react';
import PropTypes from 'prop-types';

const Reg = ({ reg }) => {

    var regSplit = reg.match(/[a-zA-Z]+|[0-9]+/g),
        ammendedReg = '';
    
    if (regSplit.length !== 3) {
        ammendedReg = [reg];
    } else {
        ammendedReg = regSplit[0] + " " + regSplit[1] + " "  + regSplit[2];
        ammendedReg = regSplit;
    }
    return (
        ammendedReg.map((str) =>
            <span className="regSpace" key={str}>{str}</span>
        )
    );
};

Reg.propTypes = {
    reg: PropTypes.string
};

export default Reg;



// WEBPACK FOOTER //
// ./src/components/Reg.jsx